var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeroBanner'),_c('CaseTypes'),_c('ProcessSteps'),_c('WhyChooseUs'),_c('TypesOfCases'),_c('Testimonials'),_c('Faq'),_c('CtaSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }